<template>
  <v-list-item>
    <template v-slot:default="{ active }">
      <v-list-item-action>
        <v-checkbox :input-value="active"></v-checkbox>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>{{ text }}</v-list-item-title>
        <v-list-item-subtitle v-if="twoLineValue">{{ subtitle }}</v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-icon>
        <v-tooltip bottom open-delay="600">
          <template v-slot:activator="{ on }">
            <v-icon
                :color="readOnly ? 'primary' : 'grey lighten-1'"
                @click.stop="readOnlyClicked"
                v-on="on"
            >
              mdi-pencil-off
            </v-icon>
          </template>
          <span>
            {{ readOnly ? $t('app.tooltip.clickToDisableReadOnly') : $t('app.tooltip.clickToEnableReadOnly') }}
          </span>
        </v-tooltip>
      </v-list-item-icon>
    </template>
  </v-list-item>
</template>

<script>
export default {
  props: ["item"],
  inject: ["unassignedValue", "unassignedText", "twoLineValue"],
  data() {
    return {
      readOnly: false,
    }
  },
  computed: {
    text() {
      return this.unassignedText(this.item)
    },
    subtitle() {
      return this.twoLineValue ? this.twoLineValue(this.item) : ""
    },
  },
  methods: {
    readOnlyClicked() {
      this.readOnly = !this.readOnly
      this.$emit("read-only", {itemValue: this.unassignedValue(this.item), readOnly: this.readOnly})
    },
  }
}
</script>